import config from "src/config";
import axios from 'axios';
import i18n from '../i18n';
import Swal from "sweetalert2";
import { convertMessageCodeToMessage } from "src/utils/messageCodeToMessage";
import { getFilterKeys } from "src/utils/commonUtils";

const getRequestHeaders = () => {
    try {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
            'Accept-Language':i18n.language
        }
    } catch (error) {
        return null;
    }
}

const getQueryStringFromObject = (obj) => {
    let queryString = '';
    let queryStringArray = [];
    for (const [key, value] of Object.entries(obj)) {
        queryStringArray.push(`${key}=${value}`);
    }
    queryString = queryStringArray.join('&');
    return queryString;
}

const getRolesForSelection = (maxValue=null, minValue=5) => {
    let current_role_key = localStorage.getItem('role');

    if(!maxValue) {
        let temp = Object.keys(config.ROLES).find(role => config.ROLES[role].key === current_role_key);
        let current_role = config.ROLES[temp];
        maxValue = current_role.value;
    }

    let roles = [];
    for (const [key, value] of Object.entries(config.ROLES)) {
        if(value.value < maxValue && value.value >= minValue) {
            roles.push({
                id: value.key,
                label: value.key
            });
        }
    }
    return roles;
}

const getRestaurantTypesForSelection = () => {
    let restaurant_types = [];
    for (const [key, value] of Object.entries(config.RESTAURANT_TYPES)) {
        restaurant_types.push({
            id: value.key,
            label: value.key
        });
    }
    return restaurant_types;
}

const getItemTagsForSelection = () => {
    let item_tags = [];
    for (const [key, value] of Object.entries(config.ITEM_TAGS)) {
        item_tags.push({
            id: value.key,
            label: value.key
        });
    }
    return item_tags;
}
const getCountries = async () => {
    try {
        let response;
        try {
            response = await axios.get( config.SERVER_BASE_URL + '/countries');
        } catch (error) {
            return error.response?.data;
        }
        return response?.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getContinents = async () => {
    try {
        let response;
        try {
            response = await axios.get( config.SERVER_BASE_URL + '/continents');
        } catch (error) {
            return error.response?.data;
        }
        return response?.data;
    } catch (error) {
        return { error: error.message };
    }
}

const exportFile = async ({
    filters = {},
    search = "",
    sort_key="",
    sort_order="",
    apiFunction,
    fileName = "exported_file",
    onStart = () => {},
    onComplete = () => {},
  }) => {
    try {
      onStart();
      let query = {};

      getFilterKeys(filters,query);
    
  
      if (search) {
        query.search = search;
      }

      if(sort_key){
        query['sort_key'] = sort_key,
        query['sort_order'] = sort_order 
      }
  
      const response = await apiFunction(query);
  
      if (response.error) {
        Swal.fire({
          icon: "error",
          title: i18n.t("error"),
          text: response?.error?.error_code
            ? i18n.t(convertMessageCodeToMessage(response?.error_code))
            : response?.error,
          confirmButtonText: i18n.t("ok"),
          confirmButtonColor: config.primaryColor,
        });
      } else {
        const newBlob = new Blob([response]);
        const blobUrl = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${i18n.t(fileName)}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: i18n.t("error"),
        text: i18n.t("unexpected_error"),
        confirmButtonText: i18n.t("ok"),
        confirmButtonColor: config.primaryColor,
      });
    } finally {
      onComplete();
    }
  };


export {
    getRequestHeaders,
    getQueryStringFromObject,
    getRolesForSelection,
    getRestaurantTypesForSelection,
    getItemTagsForSelection,
    getCountries,
    getContinents,
    exportFile
}